export function TrustBar() {
  const features = [
    { icon: 'ri-book-open-line', label: 'Professional Publishing' },
    { icon: 'ri-user-star-line', label: 'Author Branding' },
    { icon: 'ri-newspaper-line', label: 'Media Visibility' },
    { icon: 'ri-headphone-line', label: 'Audiobook Production' },
    { icon: 'ri-global-line', label: 'Translation Services' },
    { icon: 'ri-film-line', label: 'Adaptation Readiness' }
  ];

  return (
    <section className="bg-[#1A1A1A] py-20">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="flex items-center justify-between gap-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="flex flex-col items-center gap-3 group cursor-pointer transition-transform hover:scale-105"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className={`${feature.icon} text-[#D4AF37] text-5xl group-hover:brightness-125 transition-all`}></i>
              </div>
              <span className="text-white text-sm font-medium text-center max-w-[120px]">
                {feature.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}